<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Scheduled DevOps Actions</h1>

<div>
    <!-- Loading -->
    <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

    <p>Select <strong>Customer</strong> Or <strong>Account</strong> Or <strong>Environment</strong> Or
        <strong>Region</strong>.<br /> Select none to fetch all
    </p>
    <div class="button-div">
        <mat-form-field class="fetch-action-button">
            <mat-label>Fetch Actions For</mat-label>
            <mat-select [(ngModel)]="selectedFetchOption" [ngModelOptions]="{standalone: true}"
                (selectionChange)="onGetDevOpsActionParameterChanged(selectedFetchOption)">
                <mat-option value="Customer">
                    <span>Customer</span>
                </mat-option>
                <mat-option value="Account">
                    <span>Account</span>
                </mat-option>
                <mat-option value="Environment">
                    <span>Environment</span>
                </mat-option>
                <mat-option value="Region">
                    <span>Region</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="fetchDevOpsActionErrors">
        <!-- Fetch DevOps Actions Response Errors -->
        <p>Error: {{fetchDevOpsActionErrors}}</p>
    </div>

    <!-- Customer grid -->
    <div *ngIf="selectedFetchOption && selectedFetchOption === 'Customer'" class="ag-grid-container">
        <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="customerGridOptions" [rowData]="cloudCutomers">
        </ag-grid-angular>
    </div>
    <!-- Account grid -->
    <div *ngIf="selectedFetchOption && selectedFetchOption === 'Account'" class="ag-grid-container">
        <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="accountGridOptions" [rowData]="cloudAccounts">
        </ag-grid-angular>
    </div>
    <!-- Environment grid -->
    <div *ngIf="selectedFetchOption && selectedFetchOption === 'Environment'" class="ag-grid-container">
        <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="environmentGridOptions" [rowData]="cloudEnvironments">
        </ag-grid-angular>
    </div>
    <div class="fetch-button-div">
        <!-- Region -->
        <mat-form-field *ngIf="selectedFetchOption && selectedFetchOption === 'Region'"
            class="fetch-action-button">
            <mat-label>Region</mat-label>
            <mat-select [(ngModel)]="selectedRegion" [ngModelOptions]="{standalone: true}"
                (selectionChange)="onGetDevOpsActionParameterChanged('Region')">
                <mat-option *ngFor="let item of supportedRegions" [value]="item">
                    <span>{{item}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Fetch DevOps Actions -->
        <button class="fetch-action-button" mat-raised-button color="primary" (click)="getDevOpsActions()"
            [disabled]="isLoading">
            <span *ngIf="!isLoading">Fetch DevOps Actions</span>
            <span *ngIf="isLoading">Loading...</span>
        </button>
        <!-- Clear -->
        <button class="fetch-action-button" mat-raised-button (click)="clearSelection()">
            <span>Clear</span>
        </button>
    </div>

    <p>DevOps Scheduled Actions Event Rules</p>

    <!-- DevOps Actions Event Rules -->
    <div class="ag-grid-container">
        <ag-grid-angular class="ag-theme-alpine ag-grid" [gridOptions]="devOpsActionGridOptions">
        </ag-grid-angular>
    </div>
    <!-- Create DevOps Action Event Rule, Delete DevOps Action Event Rule -->
    <div class="button-div">
        <button class="button-action" mat-raised-button color="primary" [routerLink]="'/erm/create-devops-actions'">
            <mat-icon>open_in_new</mat-icon>
            Create DevOps Action
        </button>
        <button class="button-action" mat-raised-button color="warn" (click)="deleteDevOpsAction()"
            [disabled]="canDeleteDevOpsAction()">
            <mat-icon>delete_forever</mat-icon>
            Delete DevOps Action
        </button>
    </div>

    <!-- Selected DevOps Action Event Rule -->
    <div *ngIf="selectedDevOpsAction">
        <p>
            <strong>Event Rule Id: {{selectedDevOpsAction.eventRuleId}}</strong> <br />
            <strong>Account Id:</strong>
            <a [routerLink]="['/erm/accounts', selectedDevOpsAction.accountId]">
                {{selectedDevOpsAction.accountId}}
            </a>
        </p>
        <pre>{{selectedDevOpsAction | json}}</pre>
    </div>
</div>